// Mirrors the backend's String.normalizeToClass and the confusion-matrix grouping in
// ClassifierMetricsService, so the drilled-down run list matches the matrix counts.
export const LOW_CONFIDENCE_THRESHOLD = 0.8

export interface ClassifierFilter {
    expectedClass?: string
    predictedClass?: string
    unmatchedOnly?: boolean
    incorrectOnly?: boolean
    lowConfidenceOnly?: boolean
}

// The empty string is a legitimate class value, so presence checks must be against undefined.
export function hasActiveClassifierFilter(filter: ClassifierFilter): boolean {
    return filter.expectedClass !== undefined || filter.predictedClass !== undefined
        || Boolean(filter.unmatchedOnly || filter.incorrectOnly || filter.lowConfidenceOnly)
}

export function normalizeToClass(value: string | null | undefined, classes: string[]): string | null {
    const trimmed = (value ?? "").trim().toLowerCase()
    return classes.find(candidate => candidate.toLowerCase() === trimmed) ?? null
}

export function matchesClassifierFilter(
    filter: ClassifierFilter,
    predicted: string | null,
    expected: string | null,
    confidence: number | null | undefined,
): boolean {
    if (filter.expectedClass !== undefined && expected !== filter.expectedClass) return false
    if (filter.predictedClass !== undefined && predicted !== filter.predictedClass) return false
    if (filter.unmatchedOnly && predicted !== null) return false
    if (filter.incorrectOnly && predicted !== null && predicted === expected) return false
    if (filter.lowConfidenceOnly && !(confidence != null && confidence < LOW_CONFIDENCE_THRESHOLD)) return false
    return true
}
